import { Badge } from 'cpool-components/general/Badge';
import { COLORS } from 'cpool-components/types';
import { useTranslation } from 'react-i18next';

type Props = (
    | {
          applicant: 1;
          hasTwoApplicants: boolean;
      }
    | {
          applicant: 2;
      }
) & {
    displayName: string;
    value: string | boolean;
};

export const HeaderNotification: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const applicantDisplay =
        props.applicant === 1
            ? t('BANK_CREDIT_REQUEST.DATA_SHARING.APPLICANT_1')
            : t('BANK_CREDIT_REQUEST.DATA_SHARING.APPLICANT_2');
    const { applicant, displayName, value } = props;
    const hasTwoApplicants = 'hasTwoApplicants' in props ? props.hasTwoApplicants : false;
    if (value === false) return null;
    if (value === true)
        return (
            <Badge color={COLORS.WHITE}>
                {hasTwoApplicants || applicant === 2 ? `${applicantDisplay}: ${displayName}` : displayName}
            </Badge>
        );

    return (
        <Badge color={COLORS.WHITE}>
            {hasTwoApplicants || applicant === 2 ? `${applicantDisplay}: ${value}` : value}
        </Badge>
    );
};
